let locks = 0;

/**
 * Reference-counted body scroll lock. Several overlays (mobile menu, project viewer,
 * video dialog) can be open at once, so each one must not stomp the others' lock.
 */
export function lockScroll() {
  locks += 1;
  if (locks === 1) {
    document.body.style.overflow = "hidden";
  }
  return () => {
    locks = Math.max(0, locks - 1);
    if (locks === 0) {
      document.body.style.overflow = "";
    }
  };
}
